var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound404Decor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 102,
    viewBox: "0 0 298 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.616 82.432V63.568H74.208V2.08H42.816L0.336001 66.592V82.432H50.592V100H74.208V82.432H89.616ZM24.672 63.568L50.592 24.4V63.568H24.672ZM106.425 51.184C106.425 82 121.257 101.44 149.913 101.44C178.857 101.44 193.545 82 193.545 51.184C193.545 20.08 178.857 0.639992 149.913 0.639992C121.257 0.639992 106.425 20.08 106.425 51.184ZM129.897 51.184C129.897 35.488 134.505 22.672 149.913 22.672C165.609 22.672 170.073 35.488 170.073 51.184C170.073 66.592 165.609 79.264 149.913 79.264C134.505 79.264 129.897 66.592 129.897 51.184ZM297.882 82.432V63.568H282.474V2.08H251.082L208.602 66.592V82.432H258.858V100H282.474V82.432H297.882ZM232.938 63.568L258.858 24.4V63.568H232.938Z",
    fill: "#CED3E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound404Decor);
export default __webpack_public_path__ + "static/media/notFound404_decor.03e2066d36fda70db0b40abf514f1d3e.svg";
export { ForwardRef as ReactComponent };